<template>
    <hts-modal
        :show="show"
        :title="$t('labels.taskModule.delete')"
        type="confirm"
        :content="$t('labels.taskModule.confirmDelete')"
        @hide="closeOverSide"
        @confirm="() => handleSubmit()" />
</template>
<script setup lang="ts">
import { initAddTask } from '../imports/form'
import { $urlSystem } from '#imports'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
    required: true
  },
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  task: {
    type: Object || Array
  }
})

const emits = defineEmits(['close', 'refreshTables', 'resetTaskSelecteds'])

const closeOverSide = () => {
  emits('close')
}

const dataAdd = ref({ ...initAddTask })

const undo = () => {
  dataAdd.value = { ...initAddTask }
}

const handleSubmit = () => {
  const api = $urlSystem.business.task.delete
  $api(api, { body: props.task }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      emits('refreshTables')
      process.client && $toast().success($t('labels.deleteTaskSuccess'))
      emits('close')
      if (Array.isArray(props.task)) {
        emits('resetTaskSelecteds')
      }
      undo()
    }
  })
}

const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})
</script>
